export const FacebookDarkIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.5 11.0586C0.5 16.2789 4.29138 20.6197 9.25 21.5V13.9164H6.625V11H9.25V8.66638C9.25 6.04138 10.9414 4.58362 13.3336 4.58362C14.0914 4.58362 14.9086 4.7 15.6664 4.81638V7.5H14.325C13.0414 7.5 12.75 8.14137 12.75 8.95862V11H15.55L15.0836 13.9164H12.75V21.5C17.7086 20.6197 21.5 16.2798 21.5 11.0586C21.5 5.25125 16.775 0.5 11 0.5C5.225 0.5 0.5 5.25125 0.5 11.0586Z"
      fill="#292E73"
      fillOpacity="0.82"
    />
  </svg>
);

export const TwitterDarkIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
      fill="#292E73"
      fillOpacity="0.82"
    />
  </svg>
);

export const LinkedInDarkIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 1.4325C0 0.64125 0.6575 0 1.46875 0H18.5312C19.3425 0 20 0.64125 20 1.4325V18.5675C20 19.3587 19.3425 20 18.5312 20H1.46875C0.6575 20 0 19.3587 0 18.5675V1.4325ZM6.17875 16.7425V7.71125H3.1775V16.7425H6.17875ZM4.67875 6.4775C5.725 6.4775 6.37625 5.785 6.37625 4.9175C6.3575 4.03125 5.72625 3.3575 4.69875 3.3575C3.67125 3.3575 3 4.0325 3 4.9175C3 5.785 3.65125 6.4775 4.65875 6.4775H4.67875ZM10.8138 16.7425V11.6988C10.8138 11.4288 10.8337 11.1587 10.9137 10.9662C11.13 10.4275 11.6238 9.86875 12.4538 9.86875C13.54 9.86875 13.9738 10.6962 13.9738 11.9113V16.7425H16.975V11.5625C16.975 8.7875 15.495 7.4975 13.52 7.4975C11.9275 7.4975 11.2137 8.3725 10.8138 8.98875V9.02H10.7938C10.8004 9.00957 10.8071 8.99915 10.8138 8.98875V7.71125H7.81375C7.85125 8.55875 7.81375 16.7425 7.81375 16.7425H10.8138Z"
      fill="#292E73"
      fillOpacity="0.82"
    />
  </svg>
);

export const WebsiteDarkIcon = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 0C4.7103 0 0 4.7103 0 10.5C0 16.2897 4.7103 21 10.5 21C16.2897 21 21 16.2897 21 10.5C21 4.7103 16.2897 0 10.5 0ZM18.8275 9.45H15.9253C15.7958 7.15181 15.1529 4.91186 14.0437 2.89485C15.3292 3.4955 16.4418 4.41147 17.2782 5.55756C18.1146 6.70365 18.6476 8.04264 18.8275 9.45ZM11.0565 2.12835C12.1432 3.56055 13.6048 6.09735 13.8148 9.45H7.3815C7.52745 6.7242 8.4252 4.1706 9.95505 2.1273C10.1356 2.1168 10.3162 2.1 10.5 2.1C10.6879 2.1 10.8717 2.1168 11.0565 2.12835ZM7.0224 2.86335C5.9892 4.8489 5.3928 7.1001 5.2815 9.45H2.17245C2.35386 8.03023 2.89446 6.68021 3.74314 5.52764C4.59181 4.37507 5.72048 3.45806 7.0224 2.86335ZM2.17245 11.55H5.29515C5.43795 14.0479 5.9934 16.2519 6.92895 18.0915C5.65025 17.4887 4.54411 16.5734 3.71276 15.43C2.8814 14.2867 2.35165 12.9522 2.17245 11.55ZM9.9225 18.8716C8.45145 17.0887 7.5831 14.5908 7.39305 11.55H13.8117C13.5933 14.4616 12.6388 17.0058 11.0785 18.8706C10.8874 18.8832 10.6963 18.9 10.5 18.9C10.3047 18.9 10.1146 18.8832 9.9225 18.8716ZM14.134 18.061C15.1368 16.1773 15.749 13.965 15.9096 11.55H18.8265C18.6493 12.9405 18.1272 14.2646 17.3076 15.4018C16.488 16.539 15.3971 17.4531 14.134 18.061Z"
      fill="#292E73"
      fillOpacity="0.82"
    />
  </svg>
);

export const LikeIcon = () => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect x="0.5" width="18" height="18" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_8235_12713" transform="scale(0.0111111)" />
      </pattern>
      <image
        id="image0_8235_12713"
        width="90"
        height="90"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAAD70lEQVR4nO2dz6tVVRTHP9vqGToyKUscaSTRpKhQEZo0kWggkvZDK2hSAyGCBjUSmqjgX2CT0hciJo0cSrNCnpVBCGXkwHrKqywxgqL8NrgJPbp7n33PXsd97nnrMzxr77W/98u+a5+zzzn3guM4juM4zpJE0oykg5LmtZgLknbW1jcYJB1QnBuS3qytcRCMmcnj2F1b59STYbIkXZN0f22tU02m0ZJ0urbWqWYCoyXpqdp6p5YJjf5KUqitOYdltQUU8hCwrbaIHKbdaIA3agvIoXdfO0matAuwMYRwoQs9VgxhRgfg2doimhiC0QC9vzQfQum4yfoQwkVTMYYMZUYDbK0tIMWQjN5SW0CKIRn9cG0BKXpltKQ7C7rfayakA3plNPB6Qd81Zio6oDdnHZJWAd8Cd7VM8XsIYaWhJFP6NKP30d5kgJ+shHRBL4yWtB54rTDNdxZauqIXRgMHgOWFOb6xENIV1Y2WtAl4xiDVlwY5OqO60cAhbBblzwxyDBNJOya8oxLjL0kran+eXiLpDklfGxnd67IBdUvHq8ADRrl6XzaitVHSDPAO8CKw1mi8q8B7wH7gPHC3Ud5byd/AAnAWOAYcDyHcaOqUMno/8JaZvMV8D6zrKPet5nNgZwgheR6fMnoeuM9a1UBZADanbjykavQqez2D5R7ghKSonymjf7XXM2geBXbFgimjf7bXMniejwVSRl+NHH8yTECZ7qnjsVigjdElW5lDZ3Us0KZ0RJM5XIkFfEbb8kUs4EbbMhsLuNF2fAp8FAu60TZcAvak9jzcaBteatrr8LMOG45K2pBq4DPahnXArKTbYg3caDs2A9tjwajRIYTfgD/GhJZL6u0TQZXZEws03cr6JXLcZ/V4HokFmoz2BXEyojdKmoz2Oj0ZMb/caGPmYgE32pYPYoG2NdqN/j9ngROxYNsZ7YvhYq4Au9rudYCXjhzmgK1N7zi60WW8DWxp2lACN7qUHYxe+m/EF8MyHifzIXpfDMuJPsvxX7x0lLMpp1HSaN/ByyLr253zILrv4KXJenQux2jfwUtzJqdRjtFep9Mcy2nkRpcxB3yY09CNbs9l4Lmc91egrEYvZaPPMNrfyH7//PaMNj6jR1xmVCpmgZO5M/kmbnQ++0II77btXFKjl9rp3cslnX0xzOfBks45pSO2GD4htf4xwGkkx6soJTN6qXG+pLMbnU/0DncOjUb/u4O3UDLIGOYjr8plXWVV4BxwuCRB7s9IvF8yyBiORI6/ApwyHquUc8DTIYQ/Ox9J8X/7mZQfNPpDm5nEWMskvSDpY0k/Fo7XluuSPpG0N6XVcRzHcRzHcRxnEPwDuSFJDiW4L4cAAAAASUVORK5CYII="
      />
    </defs>
  </svg>
);

export const PreviewIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect width="18" height="18" fill="url(#preview)" />
    <defs>
      <pattern
        id="preview"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_8235_12716" transform="scale(0.0111111)" />
      </pattern>
      <image
        id="image0_8235_12716"
        width="90"
        height="90"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const BuilderIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="white" />
    <path
      d="M33.3438 13.8438H14.6562C14.2068 13.8438 13.8438 14.2068 13.8438 14.6562V33.3438C13.8438 33.7932 14.2068 34.1562 14.6562 34.1562H33.3438C33.7932 34.1562 34.1562 33.7932 34.1562 33.3438V14.6562C34.1562 14.2068 33.7932 13.8438 33.3438 13.8438ZM20.6484 28.6719C20.0873 28.6719 19.6328 28.2174 19.6328 27.6562C19.6328 27.0951 20.0873 26.6406 20.6484 26.6406C21.2096 26.6406 21.6641 27.0951 21.6641 27.6562C21.6641 28.2174 21.2096 28.6719 20.6484 28.6719ZM20.6484 25.0156C20.0873 25.0156 19.6328 24.5611 19.6328 24C19.6328 23.4389 20.0873 22.9844 20.6484 22.9844C21.2096 22.9844 21.6641 23.4389 21.6641 24C21.6641 24.5611 21.2096 25.0156 20.6484 25.0156ZM20.6484 21.3594C20.0873 21.3594 19.6328 20.9049 19.6328 20.3438C19.6328 19.7826 20.0873 19.3281 20.6484 19.3281C21.2096 19.3281 21.6641 19.7826 21.6641 20.3438C21.6641 20.9049 21.2096 21.3594 20.6484 21.3594ZM28.3672 28.2656C28.3672 28.3773 28.2758 28.4688 28.1641 28.4688H23.4922C23.3805 28.4688 23.2891 28.3773 23.2891 28.2656V27.0469C23.2891 26.9352 23.3805 26.8438 23.4922 26.8438H28.1641C28.2758 26.8438 28.3672 26.9352 28.3672 27.0469V28.2656ZM28.3672 24.6094C28.3672 24.7211 28.2758 24.8125 28.1641 24.8125H23.4922C23.3805 24.8125 23.2891 24.7211 23.2891 24.6094V23.3906C23.2891 23.2789 23.3805 23.1875 23.4922 23.1875H28.1641C28.2758 23.1875 28.3672 23.2789 28.3672 23.3906V24.6094ZM28.3672 20.9531C28.3672 21.0648 28.2758 21.1562 28.1641 21.1562H23.4922C23.3805 21.1562 23.2891 21.0648 23.2891 20.9531V19.7344C23.2891 19.6227 23.3805 19.5312 23.4922 19.5312H28.1641C28.2758 19.5312 28.3672 19.6227 28.3672 19.7344V20.9531Z"
      fill="#7E00FD"
    />
  </svg>
);

export const RoleIcon = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="17" cy="17" r="17" fill="#9C8AC1" fillOpacity="0.16" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.375 9.6875C11.2258 9.6875 11.0827 9.74676 10.9773 9.85225C10.8718 9.95774 10.8125 10.1008 10.8125 10.25C10.8125 10.3992 10.8718 10.5423 10.9773 10.6477C11.0827 10.7532 11.2258 10.8125 11.375 10.8125V23.1875H10.8125C10.6633 23.1875 10.5202 23.2468 10.4148 23.3523C10.3093 23.4577 10.25 23.6008 10.25 23.75C10.25 23.8992 10.3093 24.0423 10.4148 24.1477C10.5202 24.2532 10.6633 24.3125 10.8125 24.3125H23.1875C23.3367 24.3125 23.4798 24.2532 23.5852 24.1477C23.6907 24.0423 23.75 23.8992 23.75 23.75C23.75 23.6008 23.6907 23.4577 23.5852 23.3523C23.4798 23.2468 23.3367 23.1875 23.1875 23.1875H22.625V10.8125C22.7742 10.8125 22.9173 10.7532 23.0227 10.6477C23.1282 10.5423 23.1875 10.3992 23.1875 10.25C23.1875 10.1008 23.1282 9.95774 23.0227 9.85225C22.9173 9.74676 22.7742 9.6875 22.625 9.6875H11.375ZM14.75 12.5C14.6008 12.5 14.4577 12.5593 14.3523 12.6648C14.2468 12.7702 14.1875 12.9133 14.1875 13.0625C14.1875 13.2117 14.2468 13.3548 14.3523 13.4602C14.4577 13.5657 14.6008 13.625 14.75 13.625H15.875C16.0242 13.625 16.1673 13.5657 16.2727 13.4602C16.3782 13.3548 16.4375 13.2117 16.4375 13.0625C16.4375 12.9133 16.3782 12.7702 16.2727 12.6648C16.1673 12.5593 16.0242 12.5 15.875 12.5H14.75ZM14.1875 15.3125C14.1875 15.1633 14.2468 15.0202 14.3523 14.9148C14.4577 14.8093 14.6008 14.75 14.75 14.75H15.875C16.0242 14.75 16.1673 14.8093 16.2727 14.9148C16.3782 15.0202 16.4375 15.1633 16.4375 15.3125C16.4375 15.4617 16.3782 15.6048 16.2727 15.7102C16.1673 15.8157 16.0242 15.875 15.875 15.875H14.75C14.6008 15.875 14.4577 15.8157 14.3523 15.7102C14.2468 15.6048 14.1875 15.4617 14.1875 15.3125ZM14.75 17C14.6008 17 14.4577 17.0593 14.3523 17.1648C14.2468 17.2702 14.1875 17.4133 14.1875 17.5625C14.1875 17.7117 14.2468 17.8548 14.3523 17.9602C14.4577 18.0657 14.6008 18.125 14.75 18.125H15.875C16.0242 18.125 16.1673 18.0657 16.2727 17.9602C16.3782 17.8548 16.4375 17.7117 16.4375 17.5625C16.4375 17.4133 16.3782 17.2702 16.2727 17.1648C16.1673 17.0593 16.0242 17 15.875 17H14.75ZM17.5625 13.0625C17.5625 12.9133 17.6218 12.7702 17.7273 12.6648C17.8327 12.5593 17.9758 12.5 18.125 12.5H19.25C19.3992 12.5 19.5423 12.5593 19.6477 12.6648C19.7532 12.7702 19.8125 12.9133 19.8125 13.0625C19.8125 13.2117 19.7532 13.3548 19.6477 13.4602C19.5423 13.5657 19.3992 13.625 19.25 13.625H18.125C17.9758 13.625 17.8327 13.5657 17.7273 13.4602C17.6218 13.3548 17.5625 13.2117 17.5625 13.0625ZM18.125 14.75C17.9758 14.75 17.8327 14.8093 17.7273 14.9148C17.6218 15.0202 17.5625 15.1633 17.5625 15.3125C17.5625 15.4617 17.6218 15.6048 17.7273 15.7102C17.8327 15.8157 17.9758 15.875 18.125 15.875H19.25C19.3992 15.875 19.5423 15.8157 19.6477 15.7102C19.7532 15.6048 19.8125 15.4617 19.8125 15.3125C19.8125 15.1633 19.7532 15.0202 19.6477 14.9148C19.5423 14.8093 19.3992 14.75 19.25 14.75H18.125ZM17.5625 17.5625C17.5625 17.4133 17.6218 17.2702 17.7273 17.1648C17.8327 17.0593 17.9758 17 18.125 17H19.25C19.3992 17 19.5423 17.0593 19.6477 17.1648C19.7532 17.2702 19.8125 17.4133 19.8125 17.5625C19.8125 17.7117 19.7532 17.8548 19.6477 17.9602C19.5423 18.0657 19.3992 18.125 19.25 18.125H18.125C17.9758 18.125 17.8327 18.0657 17.7273 17.9602C17.6218 17.8548 17.5625 17.7117 17.5625 17.5625ZM14.75 22.625V20.9375C14.75 20.7883 14.8093 20.6452 14.9148 20.5398C15.0202 20.4343 15.1633 20.375 15.3125 20.375H18.6875C18.8367 20.375 18.9798 20.4343 19.0852 20.5398C19.1907 20.6452 19.25 20.7883 19.25 20.9375V22.625C19.25 22.7742 19.1907 22.9173 19.0852 23.0227C18.9798 23.1282 18.8367 23.1875 18.6875 23.1875H15.3125C15.1633 23.1875 15.0202 23.1282 14.9148 23.0227C14.8093 22.9173 14.75 22.7742 14.75 22.625Z"
      fill="black"
    />
  </svg>
);

export const AttachIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2929 7.36726L8.16621 13.4939C7.41565 14.2445 6.39766 14.6662 5.33621 14.6662C4.27475 14.6662 3.25677 14.2445 2.50621 13.4939C1.75565 12.7434 1.33398 11.7254 1.33398 10.6639C1.33398 9.60248 1.75565 8.58449 2.50621 7.83393L8.63288 1.70726C9.13325 1.20689 9.8119 0.925781 10.5195 0.925781C11.2272 0.925781 11.9058 1.20689 12.4062 1.70726C12.9066 2.20764 13.1877 2.88629 13.1877 3.59393C13.1877 4.30157 12.9066 4.98022 12.4062 5.4806L6.27288 11.6073C6.02269 11.8575 5.68336 11.998 5.32954 11.998C4.97572 11.998 4.6364 11.8575 4.38621 11.6073C4.13602 11.3571 3.99547 11.0177 3.99547 10.6639C3.99547 10.3101 4.13602 9.97079 4.38621 9.7206L10.0462 4.06726"
        stroke="#7E00FD"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DeleteAttachIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10.2275" cy="10" r="10" fill="#7E00FD" />
      <path
        d="M13.6025 6.625L6.85254 13.375"
        stroke="white"
        strokeWidth="1.75424"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6025 13.375L6.85254 6.625"
        stroke="white"
        strokeWidth="1.75424"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AttachThumbIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_15756)">
        <path
          d="M25.7411 8.82192H30.6003L22.6377 0.876953V5.71847C22.6394 7.4316 24.028 8.82019 25.7411 8.82192Z"
          fill="#9C8AC1"
          fillOpacity="0.16"
        />
        <path
          d="M14.6574 7.95376C14.6574 8.91839 13.8753 9.70049 12.9106 9.70049C11.9457 9.70049 11.1636 8.91839 11.1636 7.95376C11.1636 6.98913 11.9457 6.20703 12.9106 6.20703C13.8753 6.20703 14.6574 6.98913 14.6574 7.95376Z"
          fill="#9C8AC1"
          fillOpacity="0.16"
        />
        <path
          d="M21.3959 5.71921V0H7.62542C5.91229 0.00173183 4.5237 1.39032 4.52197 3.10345V32.8966C4.5237 34.6097 5.91229 35.9983 7.62542 36H28.3565C30.0697 35.9983 31.4579 34.6097 31.46 32.8966V10.064H25.7408C23.3429 10.0602 21.3997 8.11711 21.3959 5.71921ZM12.9103 4.97452C14.5618 4.97452 15.8998 6.31393 15.8984 7.9654C15.8967 9.61688 14.5555 10.9539 12.9041 10.9507C11.2526 10.9476 9.91699 9.60511 9.92183 7.95363C9.92772 6.307 11.2637 4.97522 12.9103 4.97452ZM8.7428 16.2356C8.7428 13.934 10.6087 12.0681 12.9103 12.0681C15.2119 12.0681 17.0778 13.934 17.0778 16.2356V16.945C17.0778 17.2875 16.7996 17.5657 16.4571 17.5657C16.1142 17.5657 15.8364 17.2875 15.8364 16.945V16.2356C15.8364 14.6195 14.5261 13.3095 12.9103 13.3095C11.2941 13.3095 9.98418 14.6195 9.98418 16.2356V16.945C9.98418 17.2875 9.70605 17.5657 9.36349 17.5657C9.02059 17.5657 8.7428 17.2875 8.7428 16.945V16.2356ZM9.36349 21.6888H20.4116C20.7545 21.6888 21.0322 21.9666 21.0322 22.3095C21.0322 22.6521 20.7545 22.9302 20.4116 22.9302H9.36349C9.02059 22.9302 8.7428 22.6521 8.7428 22.3095C8.7428 21.9666 9.02059 21.6888 9.36349 21.6888ZM27.2391 29.0218C27.2402 29.1866 27.1751 29.3449 27.0587 29.4616C26.942 29.5784 26.7833 29.6435 26.6185 29.6424H9.36349C9.02059 29.6424 8.7428 29.3643 8.7428 29.0218C8.7428 28.6788 9.02059 28.4011 9.36349 28.4011H26.6185C26.961 28.4021 27.2381 28.6792 27.2391 29.0218Z"
          fill="#9C8AC1"
          fillOpacity="0.16"
        />
        <ellipse
          cx="17.625"
          cy="26.625"
          rx="10.875"
          ry="7.875"
          fill="#EFECF5"
        />
        <g clipPath="url(#clip1_1_15756)">
          <path
            d="M22.2205 32.4574H19.7961H19.1432H19.0022V29.2054H20.0658C20.3355 29.2054 20.4949 28.8989 20.3355 28.6782L18.2667 25.8155C18.1349 25.6316 17.8621 25.6316 17.7303 25.8155L15.6614 28.6782C15.502 28.8989 15.6584 29.2054 15.9311 29.2054H16.9947V32.4574H16.8537H16.2009H13.3903C11.7812 32.3685 10.5 30.8636 10.5 29.233C10.5 28.1082 11.1099 27.1274 12.0141 26.5971C11.9313 26.3734 11.8884 26.1343 11.8884 25.883C11.8884 24.7336 12.8171 23.8049 13.9665 23.8049C14.2148 23.8049 14.4538 23.8478 14.6776 23.9306C15.3427 22.5207 16.7771 21.543 18.4444 21.543C20.6022 21.546 22.3799 23.1981 22.5821 25.3037C24.2403 25.5887 25.5 27.1243 25.5 28.8621C25.5 30.7195 24.0533 32.3286 22.2205 32.4574Z"
            fill="#7E00FD"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1_15756">
          <rect width="36" height="36" fill="white" />
        </clipPath>
        <clipPath id="clip1_1_15756">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(10.5 19.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

